module.exports = __webpack_public_path__ + "static/why-we-cant-wait-3a9b97088dcf7ca14ac13fd516bcf701.jpg";